import React, { useRef } from 'react';

import { LightDangerouslyHtml } from 'apps/promo/components/common/fromAuth/LightDangerouslyHtml/LightDangerouslyHtml';
import { PromoInfoPage } from 'apps/promo/components/common/PromoInfoPage/PromoInfoPage';
import PromoPopup from 'apps/promo/components/popup/PromoPopup';
import { AUTH_PROFILE_INVITE, AUTH_SEND_MAIN_LINK } from 'apps/promo/constants/UrlConstants';
import { usePageMessages } from 'apps/promo/hooks/selectors';

const PromoFailed = (props) => {
    const popupRef = useRef(null);
    const { headerTitle, statusText, statusCancelTitle } = usePageMessages();

    return (
        <>
            <PromoInfoPage
                animatedIconFail
                headerText={headerTitle}
                secondaryText={<LightDangerouslyHtml dangerouslyHtml={statusText} />}
                primaryButtonCaption={statusCancelTitle}
                primaryButtonType="link"
                primaryButtonLink={props.status && props.status.showInviteCodeReferralButton ? AUTH_PROFILE_INVITE : AUTH_SEND_MAIN_LINK}
            />
            <PromoPopup ref={popupRef} />
        </>
    );
};

export default PromoFailed;
